import {useForm} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Group, Modal, ModalProps, Stack, Switch} from "@mantine/core";
import {useCallback} from "react";
import {transportMethod} from "@ots-frontend/ots-data";
import {InputInfoTooltip} from "../../tooltip/InfoTooltip/InfoTooltip";

interface ContainerDNUChartFormProps {
  defaultValues?: Partial<ContainerDNUChartFormValues>;
  onSubmit?: (values: ContainerDNUChartFormValues) => void;
}

export interface ContainerDNUChartFormValues {
  includeTrucking?: boolean
  includePipeline?: boolean
  splitHaulMethods?: boolean
}

export const ContainerDNUChartForm = (props: ContainerDNUChartFormProps) => {
  const {
    defaultValues,
    onSubmit,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: {
      includeTrucking: defaultValues?.includeTrucking,
      includePipeline: defaultValues?.includePipeline,
      splitHaulMethods: defaultValues?.splitHaulMethods,
    },
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        includeTrucking: values.includeTrucking,
        includePipeline: values.includePipeline,
        splitHaulMethods: values.splitHaulMethods,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Stack spacing="md">
        <Switch
          label={
            <Group spacing={"xs"}>
              {t(transportMethod.trucking.displayValue.id, transportMethod.trucking.displayValue.defaultMessage)}
            </Group>
          }
          {...form.getInputProps("includeTrucking", {type: 'checkbox'})} />
        <Switch
          label={
            <Group spacing={"xs"}>
              {t(transportMethod.pipeline.displayValue.id, transportMethod.pipeline.displayValue.defaultMessage)}
            </Group>
          }
          {...form.getInputProps("includePipeline", {type: 'checkbox'})} />
        <Divider/>
        <Switch
          label={
            <Group spacing={"xs"}>
              {t("common.insight.containerdnu.chart.form.field.splithaulmethods", "Split Haul Methods")}
              <InputInfoTooltip label={"Whether or not to split the data set by haul methods (i.e. Trucking, Pipeline)."}/>
            </Group>
          }
          {...form.getInputProps("splitHaulMethods", {type: 'checkbox'})} />
      </Stack>
      <Button type="submit" fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};

interface ContainerDNUChartFormModalProps extends ContainerDNUChartFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const ContainerDNUChartFormModal = (props: ContainerDNUChartFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <ContainerDNUChartForm defaultValues={defaultValues} onSubmit={onSubmit}/>
    </Modal>
  );
};
